<template>
  <div>
    <v-btn text depressed outlined
           v-bind="$attrs"
           v-on="$listeners"
           :color="color"
           :disabled="desabilitado || salvamentoEmAndamentoOuErro"
           :class="{'btn-disabled': desabilitado}">
        <v-icon v-if="!esconderIcone && !iconeDireito" :size="tamanhoIcone" :color="color" class="mr-1">{{icone}}</v-icon>
        <span :class="{'text-capitalize':textCapitalize}">{{textoBotao}}</span>
        <v-icon v-if="!esconderIcone && iconeDireito" :size="tamanhoIcone" :color="color" class="ml-1">{{icone}}</v-icon>
    </v-btn>
  </div>
</template>

<script>
    import {mapState} from 'vuex'

    export default {
        name: 'Botao',
        props: {
            textCapitalize: {
                type: Boolean,
                default: false
            },
            textoBotao: {
                type: String,
                default: 'Voltar'
            },
            outlined: {
                type: Boolean,
                default: false
            },
            desabilitado: {
                type: Boolean,
                default: false
            },
            color: {
                type: String,
                default: 'grey'
            },
            esconderIcone: {
                type: Boolean,
                default: false
            },
            iconeDireito: {
                type: Boolean,
                default: false
            },
            icone: {
                type: String,
                default: 'fas fa-arrow-left'
            },
            tamanhoIcone: {
                type: String,
                default: '15'
            },
        },
        computed:{
            ...mapState({
                salvamentoAutomaticoEmAndamento: state => state.loki.autoSave.saving,
                salvamentoAutomaticoComErro: state => state.isSalvamentoAutomaticoErro
            }),
            salvamentoEmAndamentoOuErro() {
                return !!(this.salvamentoAutomaticoEmAndamento || this.salvamentoAutomaticoComErro)
            },
        }
    }
</script>

<style lang="stylus" scoped>

</style>
